import React, { useCallback, useState } from "react";

import { ActionHandlerActionCreators } from "../../redux/action-creators";
import { useDispatch } from "react-redux";

export const FullScreenPopupDemoButton = () => {
  const dispatch = useDispatch();
  const [poolID, setPoolID] = useState(75);

  const changeHandler = event => {
    setPoolID(event.target.value);
  };

  const clickHandler = useCallback(() => {
    dispatch(
      ActionHandlerActionCreators.openPokerGame({
        buttonID: "placeholder",
        poolID
      })
    );
  }, [dispatch, poolID]);

  return (
    <div className="full-screen-popup-demo-button">
      <input
        placeholder="72"
        id="poolID"
        type="number"
        name="poolID"
        className="game-frame-pool-id"
        onChange={changeHandler}
      />
      <button onClick={clickHandler}>Open Poker Blast</button>
      <div>
        <a href="/app/poker-history/">
          <button>Open Poker History</button>
        </a>
      </div>
    </div>
  );
};
